import type { AffectedMeteredEventSample, Meter } from '@vy/types';
import React from 'react';
import type { VyTableMinimalProps } from '../../../../../../../components/new-design/table/vy-table/vy-table-types';
import { VyTable } from '../../../../../../../components/new-design/table/vy-table/VyTable';
import { useMeters } from '../../../../../../../hooks/requests/use-meters/use-meters';
import { buildAffectedMeteredEventsTableColumns } from './affected-metered-events-table-consts';

type AffectedMeteredEventsTableProps = Omit<VyTableMinimalProps<AffectedMeteredEventSample>, 'tableName'>;

export const AffectedMeteredEventsTable: React.FC<AffectedMeteredEventsTableProps> = ({
  items,
  itemsCount,
  loadingItems,
}) => {
  const { data: metersResponse, isFetching } = useMeters({
    refetchOnWindowFocus: false,
  });
  const isLoading = loadingItems || isFetching;

  const meterNameIdMap = metersResponse.meters?.reduce<Record<string, Meter>>((metersMap, meter) => {
    metersMap[meter.id] = meter;

    return metersMap;
  }, {});

  const columns = buildAffectedMeteredEventsTableColumns(meterNameIdMap);
  const isNoItems = itemsCount === 0;

  return (
    <VyTable
      tableName="affected-metered-events"
      itemsCount={itemsCount}
      items={items}
      columns={columns}
      loading={isLoading}
      getRowId={(row) => row.meterId}
      showPagination={false}
      emptyTableMessageSize={50}
      sx={{
        ...(isNoItems && {
          height: '250px',
        }),

        '& .MuiDataGrid-row:last-child .MuiDataGrid-cell ': {
          borderBottom: 'none',
        },
      }}
    />
  );
};
